import React from 'react';
const facts = [{
  value: '16 000',
  label: 'pilotes licenciés',
  hint: 'de 15 à 90 ans'
}, {
  value: '1 200',
  label: 'bases réparties en France',
  hint: 'dont une majorité en terrain privé'
}, {
  value: '1 000',
  label: 'instructeurs fédéraux',
  hint: 'formation encadrée dans les six classes'
}, {
  value: '6',
  label: 'classes d’aéronefs',
  hint: 'un seul brevet par classe, valable à vie'
}];
export function AboutUlm() {
  return <section id="lulm" className="border-t border-line bg-white py-20 lg:py-28" data-id="element-1" data-mp="1axbd1zq5mkxh">
      <div className="mx-auto grid max-w-shell gap-14 px-5 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20 lg:px-8" data-id="element-2" data-mp="1fyqw5m8ruhd8">
        <div data-id="element-3" data-mp="11zr7iel9e2h2">
          <h2 className="ffp-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl lg:text-[44px]" data-id="element-4" data-mp="1200ya4e4odnt">
            Voler pour de vrai, avec deux places, un moteur et beaucoup moins de contraintes.
          </h2>
          <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-ink/70" data-id="element-5" data-mp="2wacwqc5wm8n4">
            <p data-id="element-6" data-mp="3197rmch5bnnl">
              L’ULM est une aviation de loisir réglementée mais volontairement simple : un aéronef léger de
              moins de 500 kg, un brevet délivré à vie, aucune visite médicale imposée, et la liberté
              d’atterrir sur un terrain privé avec l’accord de son propriétaire.
            </p>
            <p data-id="element-7" data-mp="2meg2zk3upge2">
              Cette simplicité repose sur la responsabilité du pilote. C’est là que la Fédération intervient :
              formation, culture de sécurité, assurance collective, et représentation auprès des autorités de
              l’aviation civile.
            </p>
          </div>
          <a href="#former" className="ffp-focus mt-9 inline-flex items-center rounded-full border border-navy px-5 py-2.5 text-[14px] font-semibold text-navy transition-colors duration-150 ease-soft hover:bg-navy hover:text-white" data-id="element-8" data-mp="28mroxba1khug">
            Comment devenir pilote
          </a>
        </div>

        <dl className="lg:pt-3" data-id="element-9" data-mp="3f2232idve2w6">
          {facts.map((fact, index) => <div key={fact.label} className={`flex items-baseline gap-6 border-t border-line py-6 ${index === facts.length - 1 ? 'border-b' : ''}`} data-id="element-10" data-mp="3n42x99i88yrm" data-mpi={index}>
              <dt className={`ffp-display shrink-0 font-extrabold text-navy ${index === 0 ? 'text-5xl lg:text-6xl' : 'text-3xl lg:text-4xl'}`} data-id="element-11" data-mp="4yfrsr9dsb">
                {fact.value}
              </dt>
              <dd data-id="element-12" data-mp="38ewrt3ssqcba">
                <span className="block text-[15px] font-semibold text-ink" data-id="element-13" data-mp="38edmcmkc1ge5">{fact.label}</span>
                <span className="mt-0.5 block text-[13px] text-ink/55" data-id="element-14" data-mp="3de9m29lzylnw">{fact.hint}</span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}